import React, { useEffect, useRef, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { AnswerItem, QuestionValidationTypes, ReduxState } from 'interface';
import { QuestionSLPRef, SLPQuestionType } from '../../questions.index';
import SLPNPS, { SLPNPSRef } from 'utilities/slp/NPS/NPS.index';
import { extractTitle } from 'scripts/string';
import { createQuestionTitle } from '../questionsTypes.script';

const SLPNPSQuestion: React.ForwardRefRenderFunction<
    QuestionSLPRef,
    ConnectedProps<typeof connector> & SLPQuestionType
> = (props: ConnectedProps<typeof connector> & SLPQuestionType, ref) => {
    React.useImperativeHandle(ref, () => ({
        validate: (e?: boolean) => validate(e),
        submit: (e?: boolean) => onSubmit(e),
    }));
    const lang = props.lang.SLP.questionsTypes;
    const question = props.question;
    const inputRef = useRef<SLPNPSRef>(null);
    const [title, setTitle] = useState(question.title);
    const index = props.answerList?.findIndex((i) => i.question.id === question.id);

    const [hint, setHint] = useState(question.description);

    useEffect(() => {
        if (question.description)
            setHint(
                createQuestionTitle(
                    question.description,
                    props.answerList,
                    props.answer?.answerer_info,
                    props.form.indicators,
                ),
            );
        setTitle(
            createQuestionTitle(question.title, props.answerList, props.answer?.answerer_info, props.form.indicators),
        );
    }, [props.answerList]);

    function validate(e?: boolean) {
        if (
            question.is_required &&
            (inputRef.current?.getValue() === null || inputRef.current?.getValue() === undefined)
        ) {
            inputRef.current?.setError(lang.scoreErr);
            if (e) return false;
        }
        return true;
    }

    function getValue(a: any) {
        if (question.validations) {
            return question.validations.find((i) => i.title === a)?.value?.toString();
        }
    }

    function setAnswer() {
        const value = inputRef.current?.getValue();
        const data = [...props.answerList];
        if (value !== null && value !== undefined && validate()) {
            const response: AnswerItem = {
                value: value.toString(),
                question: props.question,
                id: question.id,
                answer: props.answer?.id,
            };
            if (index !== undefined && index > -1) data[index] = response;
            else data?.push(response);
        } else if (index !== undefined && index > -1) data.splice(index, 1);
        props.setAnswerList(data);
    }

    function onSubmit(e?: boolean) {
        const value = inputRef.current?.getValue();
        if (value !== null && value !== undefined && validate(e) && props.answer)
            props.submit({
                value: value.toString(),
                question: question,
                id: new Date().getTime(),
                created_at: new Date().toISOString(),
            });
    }

    return (
        <SLPNPS
            color={props.form?.answer_color}
            labelColor={props.form?.question_color}
            startTitle={getValue(QuestionValidationTypes.startTitle)}
            middleTitle={getValue(QuestionValidationTypes.middleTitle)}
            endTitle={getValue(QuestionValidationTypes.endTitle)}
            hint={extractTitle(hint, false, false)}
            ref={inputRef}
            onChange={setAnswer}
            counter={props.counter}
            label={extractTitle(title, false, false)}
            image={question.image_file}
            required={question.is_required}
            dir={props.form.direction}
            defaultValue={
                index !== undefined && index > -1 && props.answerList[index].value
                    ? Number(props.answerList[index].value)
                    : undefined
            }
        />
    );
};
const mapStateToProps = (state: ReduxState) => ({
    direction: state.direction,
    lang: state.lang,
});

const connector = connect(mapStateToProps, null, null, { forwardRef: true });
export default connector(React.forwardRef(SLPNPSQuestion));
